export type CardFields = {
  card_holder_name?: string;
  card_expiration_date?: string;
  card_number?: string;
  card_cvv?: string;
};

export type CardValidation = Record<keyof CardFields, boolean>;

export class GatewayLoadError extends Error {
  readonly cause: unknown;

  constructor(cause: unknown) {
    super("Falha ao carregar a biblioteca do gateway de pagamento");
    this.name = "GatewayLoadError";
    this.cause = cause;
  }
}

export const loadGateway = async () => {
  try {
    const gatewayModule = await import("pagarme/browser");
    return gatewayModule.default ?? gatewayModule;
  } catch (error) {
    throw new GatewayLoadError(error);
  }
};

export const validateCardWithGateway = async (card: CardFields): Promise<CardValidation> => {
  const gateway = await loadGateway();
  return gateway.validate({ card }).card;
};

export const preloadGateway = async () => {
  try {
    await loadGateway();
  } catch {
    // Swallowed here: in the browser the index.html chunk-error listener reloads the page; once its retry cap is hit, the submit retries and reports.
  }
};
